import React from "react";

export const About = (props) => {
  console.log(props.data)
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/logo-2.png" className="img-responsive" alt="" />{" "}
            <img src="img/about/about-us-1.jpg" className="img-responsive" alt="" />{" "}
            {/* <br></br> */}
            {/* <br></br><br></br> */}
            <img src="img/about/about-us-2.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>
                <b>{props.data ? props.data.paragraph : "loading..."}</b>
                <a target="_blank" rel="noreferrer" href={props.data ? props.data.w4gEmail: "loading..."}><b>{props.data ? props.data.paragraph1a : "loading..."}</b></a>
                {props.data ? props.data.paragraph1b : "loading..."}
                <br></br><br></br>
                {props.data ? props.data.paragraphBullet1 : "loading..."}<br></br>
                {props.data ? props.data.paragraphBullet2 : "loading..."}<br></br>
                {props.data ? props.data.paragraphBullet3 : "loading..."}<br></br><br></br>
                {props.data ? props.data.paragraph2 : "loading..."}<br></br>
              </p>
              <h3>Vision</h3>
                <p>{props.data ? props.data.vision : "loading..."}</p>
              <h3>Mission</h3>
              <div className="list-style">
                <div className="col-lg-12 col-sm-12 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.mission.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
              <br></br>
              <h3>Core Values</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.coreValues.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
